module.exports = __webpack_public_path__ + "img/workshop_moderationskarte2.d73c669d.png";